import React, { useState, useEffect, useMemo, useRef } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import FieldInput from "../../../CustomComponents/FieldInput";
import { useDispatch, useSelector } from "react-redux";
import { urtoast } from "../../../Layouts/CustomPopup/eventEmitter";
import NumberInputBox from "../../../CustomComponents/AllCustomeInput/NumberInputBox";
import LoginLoaderButton from "../../../Common/Loader/LoginLoaderButton";
import CustomReactQuill from "../../../Common/CustomeLabel/ReactQuill/CustomReactQuill";
import { getIndustry, getWithParentCategary } from "../../../../redux/categary/action";
import { descriptionvalidation, filesvalidationforstatusbase, nospecialtitle, titlevalidation } from "../../../Common/commonvalidation";
import AsteriskLabel from "../../../Common/AsteriskLabel";
import CoverImages from "../../../Common/CoverImages";
import CommonIndustryOption from "../../../Common/CommonIndustryOption";
import CommonCategoryOption from "../../../Common/CommonCategoryOption";

const bxpDatatomap = [
  { title: (<>Service Title <AsteriskLabel /></>), name: "title", placeholder: "Enter Title" },
  { title: (<>Cover Image </>), name: "files", placeholder: "Drag and drop or Browse file" },
  { title: (<>Description <AsteriskLabel /></>), name: "description", placeholder: "Type here" },
  { title: (<>Industry <AsteriskLabel /></>), name: "industry_id", placeholder: "Select industry" },
  { title: (<>Category <AsteriskLabel /></>), name: "category_id", placeholder: "Select Category" },
  { title: (<>Project duration <AsteriskLabel /></>), name: "duration_type", placeholder: "Project duration" },
  { title: (<>No of day <AsteriskLabel /></>), name: "duration", placeholder: "Enter No of day required" },
  { title: (<>Requirements <AsteriskLabel /></>), name: "requirements", placeholder: "Project Requirements if any" },
];

const SyncParent = ({ values, setbxpData, updateindex, initialValues, setChangesIsThere }) => {
  const lastSynced = useRef("");
  const initialSnapshot = useRef(null);

  if (initialSnapshot.current === null) {
    initialSnapshot.current = JSON.stringify(initialValues);
  }

  useEffect(() => {
    const currentValues = JSON.stringify(values);
    if (lastSynced.current !== currentValues) {
      if (updateindex === null && Object.keys(values).length > 0) {
        setbxpData((prev) => ({ ...prev, ...values }));
      }
      const hasChanges = currentValues !== initialSnapshot.current;
      setChangesIsThere(hasChanges);
      lastSynced.current = currentValues;
    }
  }, [values, updateindex, setbxpData, setChangesIsThere]);
  return null;
};

const BXPDetails = ({ updateindex, bxpData, setbxpData, setActiveTab, setChangesIsThere }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(null);
  const [selectCategory, setSelectCategory] = useState(null);
  const [selectedIndustry, setSelectedIndustry] = useState("");

  const categarylist = useSelector((state) => state.categary.categarylist);
  const TheIndustryList = useSelector(({ categary: { industrylist } }) => industrylist);

  const initialValues = useMemo(() => {
    return {
      title: bxpData?.title || "",
      files: bxpData?.files || [],
      cover: bxpData?.cover || (bxpData.files && bxpData.files[0]?.file),
      industry_id: bxpData?.industry_id || "",
      category_id: bxpData?.category_id || "",
      description: bxpData?.description || "",
      duration_type: bxpData?.duration_type ? String(bxpData?.duration_type) : "2",
      duration: bxpData?.duration || "",
      requirements: bxpData?.requirements || "",
    };
  }, [bxpData]);

  const validationSchema = Yup.object().shape({
    title: nospecialtitle,
    industry_id: Yup.string().required("Industry is required"),
    files: filesvalidationforstatusbase,
    category_id: Yup.string().required("Category is required"),
    description: descriptionvalidation,
    duration_type: Yup.string().required("Project duration type is required"),
    duration: Yup.number().required("Duration is required").positive().integer(),
    requirements: descriptionvalidation,
  });

  const path = "Assets/scss/FirstTimeUsers.module.scss";

  useEffect(() => {
    LoadCSSforfirstTime(path);
    dispatch(getIndustry());
  }, [path]);

  useEffect(() => {
    if (bxpData?.industry_id) {
      setSelectedIndustry(bxpData?.industry_id);
    }
  }, [bxpData?.industry_id]);

  useEffect(() => {
    if (selectedIndustry) {
      dispatch(getWithParentCategary(selectedIndustry));
    }
  }, [selectedIndustry]);

  useEffect(() => {
    if (bxpData?.category_id && categarylist?.length) {
      const selectedCategory = categarylist.find((item) => item.id == bxpData?.category_id);
      setSelectCategory(selectedCategory ? { value: selectedCategory.id, label: selectedCategory.title } : null);
    } else if (updateindex == null) {
      setSelectCategory(null);
    }
  }, [updateindex, bxpData?.category_id, categarylist]);

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const updatedData = { ...bxpData, ...values };
      setbxpData(updatedData);
      setActiveTab("WorkSamples");
      // Reset changes tracking after successful submission
      setChangesIsThere(false);
    } catch (error) {
      urtoast(error.message, 2);
    } finally {
      setTimeout(() => setLoading(false), 1000);
    }
  };

  return (
    <div>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize={updateindex !== null}
      >
        {(formik) => {
          return (
            <Form>
              <SyncParent
                values={formik.values}
                setbxpData={setbxpData}
                updateindex={updateindex}
                initialValues={initialValues}
                setChangesIsThere={setChangesIsThere}
              />
              <div>
                {bxpDatatomap.map((prop, key) => {
                  if (prop.name == "files") {
                    return (
                      <div className="form-group upload-item-images" key={key}>
                        <CoverImages
                          formik={formik}
                          doctype={1}
                          type={"multiple"}
                          name={prop.name}
                          title={prop.title}
                        />
                        <ul className="border-ul">
                          <li>Images (JPG, PNG, JPEG up to 10MB)</li>
                        </ul>
                      </div>
                    );
                  }

                  if (prop.name == "duration_type") {
                    return (
                      <div key={key} className="form-group">
                        <label>{prop.title}</label>
                        <div className="label-check">
                          {["2", "3", "4"].map((val, i) => (
                            <label key={i} className="checkbox-container">
                              <Field type="radio" name={prop.name} value={val} />
                              <span className="checkmark">
                                {["Days", "Weeks", "Month"][i]}
                              </span>
                            </label>
                          ))}
                        </div>
                        <ErrorMessage name={prop.name} component="div" className="error" />
                      </div>
                    );
                  }

                  if (prop.name == "description" || prop.name == "requirements") {
                    return (
                      <div key={key}>
                        <CustomReactQuill
                          value={formik.values[prop.name]}
                          formik={formik}
                          name={prop.name}
                          title={prop.title}
                        />
                        <ErrorMessage name={prop.name} component="div" className="error" />
                      </div>
                    );
                  }

                  if (prop.name == "industry_id") {
                    return (
                      <CommonIndustryOption
                        key={key}
                        options={TheIndustryList}
                        formik={formik}
                        prop={prop}
                        setSelectedIndustry={setSelectedIndustry}
                        setSelectCategory={setSelectCategory}
                      />
                    );
                  }

                  if (prop.name == "category_id") {
                    return (
                      <CommonCategoryOption
                        key={key}
                        formik={formik}
                        prop={prop}
                        options={categarylist}
                        selectCategory={selectCategory}
                        setSelectCategory={setSelectCategory}
                      />
                    );
                  }

                  if (prop.name == "duration") {
                    const durationLabel =
                      formik.values.duration_type == 1
                        ? "Hour"
                        : formik.values.duration_type == 2
                          ? "Days"
                          : formik.values.duration_type == 3
                            ? "Weeks"
                            : "Months";
                    return (
                      <NumberInputBox
                        key={key}
                        type="number"
                        title={`No of ${durationLabel}`}
                        name={prop.name}
                        placeholder={`Enter No of ${durationLabel}`}
                      />
                    );
                  }

                  return (
                    <FieldInput
                      key={key}
                      title={prop.title}
                      name={prop.name}
                      placeholder={prop.placeholder}
                    />
                  );
                })}

                <div className="button-container">
                  <button className="next-button w-100" type="submit">
                    {loading ? <LoginLoaderButton /> : "Next"}
                  </button>
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default BXPDetails;